export const messages = {
	en: {
		userIntegral: {
			search: {
				title: 'Search Conditions',
				integralName: 'Account Name',
				integralNamePlaceholder: 'Please enter account name'
			},
			list: {
				title: 'User Points'
			},
			table: {
				id: 'ID',
				name: 'Account Name',
				caozuo: 'Points'
			},
			fetchError: 'Failed to fetch points data'
		}
	},
	zh: {
		userIntegral: {
			search: {
				title: '查询条件',
				integralName: '分类名',
				integralNamePlaceholder: '请输入分类名称'
			},
			list: {
				title: '商品分类'
			},
			form: {
				typeName: '名称',
			},
			placeholder: {
				typeName: '请输入分类名称'
			},
			add: {
				title: "新增商品分类"
			},
			table: {
				id: 'ID',
				typeName: '名称',
				caozuo: '操作'
			},

			fetchError: '获取数据失败'
		}
	}
}